import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import { IPlanContent } from '../typings';
import { defaultEstimatesDialog } from './common/planDefaults';
import {
  shiftOngoingKeyDetails,
  shiftVicKeyDetails,
  weekdayShiftPerk,
} from './common/shiftPlanContent';
import { InternetOfferPerk } from './common/internetOfferPerk';

export const originWeekdayShiftContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Weekday Shift']),
  content: {
    rateDiscountText: {
      defaultState: { defaultFuel: 'Rates variable on an ongoing plan' },
      VIC: { defaultFuel: 'Rates variable on a 12 month energy plan' },
    },
    keyDetails: {
      defaultState: { defaultFuel: shiftOngoingKeyDetails },
      VIC: { defaultFuel: shiftVicKeyDetails },
    },
    perkAccordion: {
      defaultState: {
        defaultFuel: [],
        dual: [InternetOfferPerk, weekdayShiftPerk],
        electricity: [InternetOfferPerk, weekdayShiftPerk],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            promobox: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-weekday-shift.svg',
            gas: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-weekday-shift.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-weekday-shift.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel:
          'Power your home with off-peak electricity rates between 9am–5pm, Monday to Friday',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/',
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
  },
};
